// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul li[data-v-cc017e34]{margin-bottom:10px!important}ul li[data-v-cc017e34]:last-child{margin-bottom:0!important}ul li p[data-v-cc017e34]{font-size:14px!important;color:#fff!important}ul li .blue[data-v-cc017e34]{color:#2a82e4!important}ul li .orange[data-v-cc017e34]{color:#fa8052!important}ul li .red[data-v-cc017e34]{color:#e25453!important}", ""]);
// Exports
module.exports = exports;
